import _ from 'lodash';

export const MIN_FIRM_SEARCH_CHARACTERS = 3;

export const toFirmOption = (firm) => ({
    value: firm.id,
    label: firm.name,
    aragProvider: firm.aragProvider,
    address: firm.address,
    postcode: firm.postcode,
});

// The selected firms must stay in the options, or the searchable list can't find their labels.
export const buildFirmSearchOptions = (selected, searchResults, extraOptions = []) => {
    const selectedOptions = (Array.isArray(selected) ? selected : [selected]).filter(o => o && o.value !== undefined);
    return _.uniqBy([...extraOptions, ...selectedOptions, ...(searchResults || []).map(toFirmOption)], 'value');
};
